import React, { useEffect, useRef, useState } from "react";

function FadeIn({ children, direction = "up", delay = 0, className = "" }) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  const getInitialStyle = () => {
    if (direction === "left") return { transform: "translateX(-40px)" };
    if (direction === "right") return { transform: "translateX(40px)" };
    if (direction === "down") return { transform: "translateY(40px)" };
    return { transform: "translateY(40px)" };
  };

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translate(0)" : getInitialStyle().transform,
        transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
}

export default FadeIn;